var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfficeLocal = function SvgOfficeLocal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 10.6c0 8.4-9.6 14.4-9.6 14.4S1 19 1 10.6a9.6 9.6 0 0 1 19.2 0Z",
    fill: "#125A40",
    stroke: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#officeLocal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 5.625c-.76 0-1.375.616-1.375 1.375v8c0 .76.616 1.375 1.375 1.375H15c.759 0 1.375-.615 1.375-1.375v-4.5c0-.76-.616-1.375-1.375-1.375h-3.125V7c0-.76-.616-1.375-1.375-1.375h-4Zm5.375 4.25v5.75H15c.345 0 .625-.28.625-.625v-4.5A.625.625 0 0 0 15 9.875h-3.125Zm-.75-.75V7a.625.625 0 0 0-.625-.625h-4A.625.625 0 0 0 5.875 7v8c0 .345.28.625.625.625h4.625v-6.5ZM6.875 7.75a.375.375 0 1 0 0 .75h.75a.375.375 0 1 0 0-.75h-.75ZM9 8.125c0-.207.168-.375.375-.375h.75a.375.375 0 0 1 0 .75h-.75A.375.375 0 0 1 9 8.125ZM6.875 9.25a.375.375 0 1 0 0 .75h.75a.375.375 0 1 0 0-.75h-.75ZM9 9.625c0-.207.168-.375.375-.375h.75a.375.375 0 0 1 0 .75h-.75A.375.375 0 0 1 9 9.625ZM6.875 10.75a.375.375 0 0 0 0 .75h.75a.375.375 0 0 0 0-.75h-.75ZM9 11.125c0-.207.168-.375.375-.375h.75a.375.375 0 0 1 0 .75h-.75A.375.375 0 0 1 9 11.125ZM6.875 12.25a.375.375 0 0 0 0 .75h.75a.375.375 0 0 0 0-.75h-.75ZM9 12.625c0-.207.168-.375.375-.375h.75a.375.375 0 0 1 0 .75h-.75A.375.375 0 0 1 9 12.625Zm4.375-1.875a.375.375 0 0 0 0 .75h.75a.375.375 0 0 0 0-.75h-.75ZM13 12.625c0-.207.168-.375.375-.375h.75a.375.375 0 0 1 0 .75h-.75a.375.375 0 0 1-.375-.375Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "officeLocal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 5)",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgOfficeLocal;